import React from 'react';
import { Box } from '@mui/material';
import BaseTypography from 'components/typography/BaseTypography';
import { ReactComponent as Logo } from 'assets/svg/logo.svg';
import BaseButton from 'components/button/BaseButton';
import { useMediaQuery } from '@mui/system';
import appTheme from 'ui-blocks/AppTheme';
import { navbarStyles } from 'layouts/pages/landing-page/components/app-bar/NavBarStyles';
import { ReactComponent as LogoSmall } from 'assets/images/affogato-logo.svg';
import { getRedirectUrlWithParams } from 'utils/utils';

export default function NavBar() {
	const isTabletSmall = useMediaQuery(appTheme.breakpoints.down('tabletMid'));
	return (
		<Box id="nav-bar" sx={navbarStyles.container}>
			<BaseButton href="/" id="logo-button" sx={{ padding: '0px' }}>
				{isTabletSmall ? <LogoSmall /> : <Logo />}
			</BaseButton>
			<BaseButton
				id="launch-app-button"
				sx={navbarStyles.buttonStyles}
				href={getRedirectUrlWithParams('https://app.affogato.ai/')}
				target="_blank"
				rel="noopener noreferrer"
			>
				<BaseTypography variant="b1_bold" sx={{ textTransform: 'none' }}>
					Launch app
				</BaseTypography>
			</BaseButton>
		</Box>
	);
}
